export type InitializationData = {
  domain: string
  endpointId: string
  subscribeCustomerIfCreated?: boolean
  shouldCreateCustomer?: boolean
  previousInstallId?: string
  previousUuid?: string
}
